import React from 'react'
import { useTranslations } from '@npco/utils-translations'

import { transferRemittancesButtonsTranslations } from '../../TransferRemittancesButtons/TransferRemittancesButtons.i18n'
import { TransferRemittancesModal } from '../TransferRemittancesModal'
import { EmailRemittanceFields } from './EmailRemittanceFields/EmailRemittanceFields'

type EmailRemittanceModalProps = {
  isOpen: boolean
  closeModal: () => void
  currentUserEmail: string
}

export const EmailRemittanceModal = ({
  isOpen,
  closeModal,
  currentUserEmail,
}: EmailRemittanceModalProps) => {
  const t = useTranslations(transferRemittancesButtonsTranslations)

  return (
    <TransferRemittancesModal
      isOpen={isOpen}
      onCancel={closeModal}
      onSend={closeModal}
      title={t('emailRemittance')}
      description={t('emailRemittanceDescription')}
    >
      <EmailRemittanceFields
        checkBoxDescription={t('emailRemittanceCheckBox')}
        placeholder={t('email')}
        currentUserEmail={currentUserEmail}
      />
    </TransferRemittancesModal>
  )
}
